import React, { useState } from 'react';
import { shortString } from '@/utils/global';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import { dayjs } from '../../../../../../utils/dayjs-utils';
import GeneralTableData from '../../../../../common-components/GeneralTable/GeneralTableData';
import RequestUsageRightsModal from '../../modals/RequestUsageRightsModal';
import ViewUsageRightsModal from '../../modals/ViewUsageRightsModal';
import UsageRequestButton from '../../UsageRequestButton';
import { useCampaignDetail } from '../CampaignDetailProvider';
import ActionsSection from './ActionsSection';
import ContentListTableItemBlocked from './ContentListTableItemBlocked';
import ContentListTableItemSkeleton from './ContentListTableItemSkeleton';
import LabelGroup from './LabelGroup';
import MediaThumbnail from './MediaThumbnail';
import MiniStat from './MiniStat';
import TypeTag from './TypeTag';

export const SocialListeningTableItem = ({ children, className = '', ...props }) => {
  return (
    <GeneralTableData className={clsx('sl-row-item', className)} {...props}>
      {children}
    </GeneralTableData>
  );
};

const ContentListTableItem = ({ row, onGetAddOnClicked, openPostPreview, index }) => {
  const { isLoadingMore } = useCampaignDetail();
  const { userSettings } = useSelector((s) => s.user);

  const [showViewUsageRightsModal, setShowViewUsageRightsModal] = useState(false);
  const [showRequestUsageRightsModal, setShowRequestUsageRightsModal] = useState(false);

  function openRequestUsageRequestModal() {
    setShowRequestUsageRightsModal(true);
  }

  function openViewUsageRequestModal() {
    setShowViewUsageRightsModal(true);
  }
  if (isLoadingMore) return <ContentListTableItemSkeleton />;

  const showBlocked = Boolean(userSettings?.postTrackingStatus);

  // disabling locked view till we do a paywall integration
  // if (showBlocked) return <ContentListTableItemBlocked row={row} onGetAddOnClicked={onGetAddOnClicked} />;

  return (
    <tr key={row._id}>
      <SocialListeningTableItem onClick={() => openPostPreview(row)}>
        <MediaThumbnail content={row} onClick={() => openPostPreview(row)} />
      </SocialListeningTableItem>
      <SocialListeningTableItem onClick={() => openPostPreview(row)} className="center-align">
        <TypeTag type={row.type} />
      </SocialListeningTableItem>
      <SocialListeningTableItem onClick={() => openPostPreview(row)}>
        <div className="influencer-container">{shortString(row?.profile?.name, 32)}</div>
      </SocialListeningTableItem>
      <SocialListeningTableItem onClick={() => openPostPreview(row)}>
        <div className="influencer-container">@{row?.profile?.username}</div>
      </SocialListeningTableItem>
      <SocialListeningTableItem onClick={() => openPostPreview(row)}>
        <div className="date-container">{dayjs(row?.creativeCreatedDate).format('DD MMM, YYYY')}</div>
      </SocialListeningTableItem>

      <SocialListeningTableItem onClick={() => openPostPreview(row)}>
        <MiniStat stat={row?.impressions} />
      </SocialListeningTableItem>
      <SocialListeningTableItem onClick={() => openPostPreview(row)}>
        <MiniStat stat={row?.comments} />
      </SocialListeningTableItem>
      <SocialListeningTableItem onClick={() => openPostPreview(row)}>
        <MiniStat stat={row?.likes} />
      </SocialListeningTableItem>
      <SocialListeningTableItem>
        <div className="flex justify-center">
          <UsageRequestButton
            status={row?.usageRightStatus}
            openView={openViewUsageRequestModal}
            openCreate={openRequestUsageRequestModal}
            requestButtonText="Send Request"
            requestSentText="Request Sent"
            negotiationButtonText="Review Request"
            buttonStyle={{
              fontSize: '14px',
            }}
          />
        </div>
      </SocialListeningTableItem>
      <SocialListeningTableItem>
        {row?.labels?.length ? (
          <LabelGroup labels={row.labels} />
        ) : (
          <div className="label-group__container--empty">--</div>
        )}
      </SocialListeningTableItem>
      <SocialListeningTableItem>
        <ActionsSection url={row?.entityUrl} post={row} />
      </SocialListeningTableItem>
      {showViewUsageRightsModal && (
        <ViewUsageRightsModal onClose={() => setShowViewUsageRightsModal(false)} post={row} />
      )}
      {showRequestUsageRightsModal && (
        <RequestUsageRightsModal onClose={() => setShowRequestUsageRightsModal(false)} post={row} />
      )}
    </tr>
  );
};

export default ContentListTableItem;
